import { moduleNames } from 'pages/Stores/components/modules';
import { createLocationsConfig } from './LocationsConfig';

export const createLocationsModule = (useAvailableItems) => ({
  moduleName: moduleNames.LOCATIONS,
  nameTranslationPath: 'locations.title',
  descriptionTranslationPath: 'locations.moduleDescription',
  iconClassName: 'bi bi-shop',
  defaultValues: { selectedItems: [] },
  isValid: (values) => values.selectedItems?.length > 0,
  buildPayload: (values) => values.selectedItems.map((item) => item.uid),
  parseApiData: (module) => ({
    selectedItems: module.locations || [],
  }),
  ConfigComponent: createLocationsConfig(useAvailableItems),
});
